module.exports = __webpack_public_path__ + "img/empty.7c7cd8a0.png";